import script from "./RecurCharges.vue?vue&type=script&setup=true&lang=js"
export * from "./RecurCharges.vue?vue&type=script&setup=true&lang=js"

import "./RecurCharges.vue?vue&type=style&index=0&id=0bcf7f7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bcf7f7c"]])

export default __exports__